import { Component, inject, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { IHelpItem } from 'src/app/shared/interfaces/IHelpItem';
import { ActionButtonComponent } from 'src/app/shared/components/action-button/action-button.component';
import { Router } from '@angular/router';
import { HelpItemService } from 'src/app/shared/services/help-item.service';
import { tap } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { CountryCode } from 'src/app/shared/interfaces/IHelpItemCountryAddOn';
import { MostRelevantItemDescriptionComponent } from '../components/most-relevant-item-description/most-relevant-item-description.component';
import { MostRelevantItemLinksComponent } from '../components/most-relevant-item-links/most-relevant-item-links.component';
import { MostRelevantItemAddOnsComponent } from '../components/most-relevant-item-add-ons/most-relevant-item-add-ons.component';

@Component({
  selector: 'app-most-relevant-item-short',
  imports: [MostRelevantItemDescriptionComponent, MostRelevantItemLinksComponent, ActionButtonComponent, TranslateModule, MostRelevantItemAddOnsComponent],
  templateUrl: './most-relevant-item-short.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './most-relevant-item-short.component.scss'
})
export class MostRelevantItemShortComponent {
  private readonly router: Router = inject(Router);
  private readonly helpItemService: HelpItemService = inject(HelpItemService);

  public readonly item: InputSignal<IHelpItem> = input.required<IHelpItem>();
  public readonly countryFilter = input<CountryCode[]>([]);

  protected goToHelpItem(): void {
    this.helpItemService
      .getCategoryUrl(this.item().category)
      .pipe(
        tap((categoryUrl: string) => {
          void this.router.navigate([`/${categoryUrl}`], {
            queryParams: { id: this.item().id }
          });
        })
      )
      .subscribe();
  }
}
